<template>
    <v-layout column fill-height>
        <Breadcrumbs v-on:selectTab="changeTab" :guia="guia" titulo="Comissões" descricao="Consulte relatórios de comissionamento conforme status." :tabs="tabOptions" />

        <!-- <Breadcrumbs v-on:selectTab="changeTab" :guia="guia" titulo="Comissões" descricao="Corretor, estamos passando por atualizações nos dados de Recibos Pagos e Informes fiscais. Prazo para regularização 22/01/20." :tabs="tabOptions" /> -->
        
        <v-layout class="main">

            <Recibos v-if="tab == 1" />

            <Processando v-if="tab == 2" />

            <Pendente v-if="tab == 3" />

            <Odonto  v-if="tab == 4" />

        </v-layout>

    </v-layout>
</template>


<script>
import Breadcrumbs from "@/components/portal/layout/Breadcrumbs";
import Recibos from "@/components/portal/comissoes/Recibos";
import Processando from "@/components/portal/comissoes/Processando";
import Pendente from "@/components/portal/comissoes/Pendente";
import Odonto from "@/components/portal/comissoes/Odonto";

export default {
  components: {
    Breadcrumbs,
    Recibos,
    Processando,
    Pendente,
    Odonto
  },
  data() {
      return {
        tab:1,
        guia: "Comissões > Recibos",
        tabOptions: [
            { id: 1, titulo: "Recibos"},
            { id: 2, titulo: "Processando"},
            { id: 3, titulo: "Em Aberto"},
            { id: 4, titulo: "Produtos Parceiros"},
        ]    
      }
  },
  methods: {
      changeTab(value){
          this.tab = value;
          this.guia = "Comissões > " + this.tabOptions[value - 1].titulo;
      }
  },
};
</script>